import {loadLibrary} from './Util';
import {LIB_URL} from '../App';

// управление слайдерами с клавиатуры
if ($('.swiper-container, .slider__nav').length) {
    loadLibrary(LIB_URL.SWIPER, () => {
        App.H.on('click', '.swiper-container', function () {
            setSwiperKeyboard(this);
        });

        App.H.on('click', '.slider__nav', function () {
            setSwiperKeyboard($(this).siblings('.swiper-container')[0]);
        });

        App.H.on('keyup', function (e) {
            const $slider = $('.swiper-container-keyboard');

            // если открыт попап галереи продукта то ничего не делаем
            if ($('[data-popup="product-gallery"]').is('._open')) {
                return;
            }

            // назад
            if ($slider.length && e.keyCode === 37) {
                if ($slider.is('.js-product-slider-thumbs')) {
                    const index = $slider.find('.swiper-slide-thumb-active').index() - 1;

                    $slider[0].swiper.slideToLoop(index);
                    App.H.trigger('product:thumbnail', index);
                } else
                    $slider[0].swiper.slidePrev();
            }

            // вперед
            if ($slider.length && e.keyCode === 39) {
                if ($slider.is('.js-product-slider-thumbs')) {
                    const index = $slider.find('.swiper-slide-thumb-active').index() + 1;

                    $slider[0].swiper.slideToLoop(index);
                    App.H.trigger('product:thumbnail', index);
                } else
                    $slider[0].swiper.slideNext();
            }
        });
    });
}

function setSwiperKeyboard(container) {
    $('.swiper-container-keyboard').removeClass('swiper-container-keyboard');
    $(container).addClass('swiper-container-keyboard');
}
